export const PIE_CHART_CENTER_LABEL_TITLE = {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333333',
    textAnchor: 'middle',
};

export const PIE_CHART_CENTER_LABEL_SUBTITLE = {
    fontSize: '16px',
    color: '#666666',
    textAnchor: 'middle',
    wrapAround: true,
};

export const PIE_CHART_CENTER_LABEL_SUBTITLE_SMALL = {
    ...PIE_CHART_CENTER_LABEL_SUBTITLE,
    fontSize: '12px',
};
